module.exports = __webpack_public_path__ + "static/media/Inter-VariableFont_slnt,wght.0c819cf9.ttf";